<!-- <div>file-uploader {{ data.id }}</div> -->
@if(config.type == 'drag-drop'){
<section
  [class]="`drag-drop w-100 rounded-3 border border-1 my-3 ${!isDraggingOver()? 'border-info-subtle': 'border-primary bg-primary-light'}`"
  dndDropzone
  [dndAllowExternal]="true"
  (dndDragover)="isDraggingOver.set(true)"
  (dragleave)="isDraggingOver.set(false)"
  (dndDrop)="onDrop($event)"
  (click)="openFileUpload()"
>
  <div
    class="drag-drop-content d-flex flex-column justify-content-center align-items-center gap-3"
  >
    @if(!isDraggingOver()){
    <icon [icon]="config.icon" size="50" color="info-dark" />
    <div class="d-flex flex-column text-center">
      <span class="fw-semibold fs-6"
        >{{ config.title! | translate
        }}<strong
          class="text-tertiary"
          [style]="`display: ${config.required? '': 'none'}`"
          >*</strong
        ></span
      >
      <span class="fw-normal fs-9">{{ config.description! | translate }}</span>
    </div>
    } @else {
    <icon [icon]="config.icon" [size]="'100'" [color]="'primary'" />
    }
  </div>
</section>
} @else {
<div class="my-3 d-flex flex-row align-items-center">
  @if(config.customInput){
  <ng-container
    *ngComponentOutlet="
      config.customInput.content;
      inputs: {
        config: config.customInput.data.config,
        data: config.customInput.data.data
      }
    "
  />
  } @else {
  <button-component [config]="configs.btn.addFile" style="flex: 1 1 1" />
  <span class="fs-9 p-2" style="flex: 1">{{
    getSimpleFileInputLabel() | translate
  }}</span>
  }
</div>
} @if(selectedFiles.length > 0){ @if((config.type == 'input' &&
!config.customInput) || config.type == 'drag-drop'){
<div class="d-flex flex-column gap-2">
  <span class="fw-medium fs-10"
    >{{ "common.file-upload.selected-files" | translate }}:</span
  >
  @for(file of selectedFiles; track file){
  <div
    class="bg-info-light rounded-3 px-3 py-2 d-flex flex-row justify-content-between align-items-center"
  >
    <span class="fs-9">{{ file.name }}</span>
    <button-component [config]="configs.btn.removeFile" [data]="file" />
  </div>
  }
</div>
} } @if(error){ @if((config.type == 'input' && !config.customInput) || config.type == 'drag-drop'){
<div class="alert alert-danger text-tertiary-dark fs-9">
  {{ error.key | translate : error.params }}
</div>
} }

<input
  type="file"
  hidden
  #fileInput
  [multiple]="config.multiple"
  [accept]="acceptedFilesExtensions"
  (change)="onFileInputChange($event)"
/>
